export default {
  namespaced: true,

  state: {
    data: {
      env: "stage",
    },
  },

  getters: {
    getEnv: (state) => state.data.env,
  },

  actions: {
    setEnv({ commit }, payload) {
      commit("SET_ENV", payload);
    },
  },

  mutations: {
    SET_ENV(state, data) {
      state.data.env = data;
    },
  },
};
